import { fetchWithHandling } from "./ApiUtils";

const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8080/api/';


//get states
export async function getAllStates() {
    return await fetchWithHandling(`${BASE_URL}states`, {
        credentials: 'include'
    });
}

//get lgas
export async function getAllLgas() {
    return await fetchWithHandling(`${BASE_URL}lgas`, {
        credentials: 'include'
    });
}

//get lgas
export async function getLgas(stateId) {
    return await fetchWithHandling(`${BASE_URL}states/${stateId}/lgas`, {
        credentials: 'include'
    });
}

//get genders
export async function getAllGenders() {
    return await fetchWithHandling(`${BASE_URL}genders`, {
        credentials: 'include'
    });
}

//get delivery methods
export async function getAllDeliveryMethods() {
    return await fetchWithHandling(`${BASE_URL}delivery-methods`, {
        credentials: 'include'
    });
}

//get marital statuses
export async function getAllMaritalStatuses() {
    return await fetchWithHandling(`${BASE_URL}marital-statuses`, {
        credentials: 'include'
    });
}
